var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?{\"babelrc\":false,\"presets\":[[\"@babel/preset-env\",{\"targets\":[\"> 1%\",\"iOS >= 8.0\",\"Android >= 4.4\",\"Chrome >= 30\",\"Safari >= 9\",\"Firefox ESR\",\"Opera 12.1\"]}]]}!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./person.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-47956247\",\"hasScoped\":false}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./person.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/map/destination/state/person.vue
// module id = 609
// module chunks = 0